import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import DesktopColumnsMobileStack from 'components/consumer/DesktopColumnsMobileStack/DesktopColumnsMobileStack';
const FluidTextBlocksContainer = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FixedWidthContainer><DesktopColumnsMobileStack>{children}</DesktopColumnsMobileStack></FixedWidthContainer>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
FluidTextBlocksContainer.propTypes = {
  children: PropTypes.node
};
export default FluidTextBlocksContainer;